/* ============================================================
   cro-fixes.js — Adorn Silver CRO house file (JS side)
   Loaded deferred from layout/theme.liquid. JS sibling of
   assets/cro-fixes.css. Delete this file + its <script> to
   roll back; nothing else references it.

   Log
   ---
   2026-08-24  T12       Clarity smart events
   2026-08-24  CRO-003   Judge.me badge dead click
   ============================================================ */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     T12 — Clarity smart events.

     Purchase cannot be tracked here: checkout is Shopflo and
     off-domain. These three are the last on-domain steps we can
     see, which makes recordings filterable by intent.

     Clarity is injected by an app embed and can land after this
     file, so events queue until window.clarity exists.
     ---------------------------------------------------------- */
  var queue = [];
  var lastSent = {};
  var clarityReady = false;

  function flush() {
    if (typeof window.clarity !== 'function') { return; }
    clarityReady = true;
    while (queue.length) {
      try { window.clarity('event', queue.shift()); } catch (e) { /* never break the page for analytics */ }
    }
  }

  function track(name) {
    // Two taps on the same button inside a second is one intent, not two.
    var now = Date.now();
    if (lastSent[name] && now - lastSent[name] < 1000) { return; }
    lastSent[name] = now;
    queue.push(name);
    flush();
  }

  if (typeof window.clarity !== 'function') {
    var tries = 0;
    var iv = setInterval(function () {
      flush();
      if (clarityReady || ++tries > 40) { clearInterval(iv); }
    }, 250);
  }

  var ADD_TO_CART =
    'button[name="add"], [data-add-to-cart], [data-add-to-cart-secondary], .pplr_atc_form [type="submit"]';
  var BEGIN_CHECKOUT =
    '[name="flo-buy-now-button"], [data-adorn-cart-btn], .flo-header-cart-btn, [data-buy-now-button], .shopify-payment-button__button';
  var CUSTOMISE =
    '.product-personalizer .ptc_button, .product-personalizer button, [data-adorn-customize]';

  // Capture phase: adorn-sticky-customize.liquid calls
  // stopImmediatePropagation on the personaliser button, and the
  // document runs before the element either way.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    if (t.closest(ADD_TO_CART)) { track('AddToCart'); }
    if (t.closest(BEGIN_CHECKOUT)) { track('BeginCheckout'); }
    if (t.closest(CUSTOMISE)) { track('Customise'); }
  }, true);

  // The personalised line item is added by the app, not by a form
  // submit, so the click above never sees it.
  window.addEventListener('pplrAddToCartCompleted', function () { track('AddToCart'); });

  /* ----------------------------------------------------------
     CRO-003 — Judge.me preview badge.

     The badge ships as a <div> with cursor:pointer and no link:
     a store-wide dead click on every PDP and product card. On a
     PDP, send it to the review widget. Product cards already
     navigate to the PDP, so leave those alone.
     ---------------------------------------------------------- */
  function scrollToReviews() {
    var target = document.getElementById('judgeme_product_reviews') ||
                 document.querySelector('.jdgm-rev-widget, .jdgm-widget.jdgm-review-widget');
    if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }

  function wireReviewBadges() {
    // VERIFIED 2026-08-24: the PDP badge lives in
    // product-info > .product-single__wrapper on this theme, not in
    // .product-single__meta. Scope to the buy box and skip the copies
    // inside product cards, which already link to their own PDP.
    var box = document.querySelector('.product-single__wrapper');
    if (!box) { return; }
    var target = document.getElementById('judgeme_product_reviews') ||
                 document.querySelector('.jdgm-rev-widget, .jdgm-widget.jdgm-review-widget');
    if (!target) { return; }

    var badges = box.querySelectorAll('.jdgm-widget.jdgm-preview-badge');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      if (b.getAttribute('data-adorn-reviews-link')) { continue; }
      if (b.closest('.product-grid-item')) { continue; }
      b.setAttribute('data-adorn-reviews-link', '1');
      b.setAttribute('role', 'link');
      b.setAttribute('tabindex', '0');
      b.style.cursor = 'pointer';
      b.addEventListener('click', scrollToReviews);
      b.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scrollToReviews(); }
      });
    }
  }

  // Both the badge and the review widget are injected late, and the
  // theme re-renders the buy box on variant change.
  wireReviewBadges();
  document.addEventListener('DOMContentLoaded', wireReviewBadges);
  if (window.MutationObserver && document.body) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) { return; }
      pending = setTimeout(function () { pending = null; wireReviewBadges(); }, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
